export default "__VITE_ASSET__DSJWBodw__"